import React from "react"
import { Col, Container, Row } from "reactstrap"

const AddUser = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col>
            <div className="border border-danger">AddUser</div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default AddUser
